// Server Action names
export const SAGA_LOAD_FENCES_TO_BE_VALIDATED = 'SAGA_LOAD_FENCES_TO_BE_VALIDATED';
export const SAGA_LOAD_FENCE = 'SAGA_LOAD_FENCE';
export const SAGA_UPDATE_FENCE = 'SAGA_UPDATE_FENCE';
export const SAGA_DELETE_FENCE = 'SAGA_DELETE_FENCE';
export const SAGA_VALIDATE_FENCE = 'SAGA_VALIDATE_FENCE';
export const SAGA_SET_FENCE_PRIMARY_POI = 'SAGA_SET_FENCE_PRIMARY_POI';
export const SAGA_SKIP_FENCE = 'SAGA_SKIP_FENCE';
export const SAGA_MARK_POI_VALIDATION_STATE_COMPLETE = 'SAGA_MARK_POI_VALIDATION_STATE_COMPLETE';
export const SAGA_ARCHIVE_POI = 'SAGA_ARCHIVE_POI';
export const SAGA_MARK_POI_UNSURE = 'SAGA_MARK_POI_UNSURE';

// POI actions
export const SET_FENCES_TO_BE_VALIDATED = 'SET_FENCES_NEEDING_VALIDATION';
export const SET_FENCE = 'SET_FENCE';
export const SET_FENCE_UPDATED = 'SET_FENCE_UPDATED';
export const REMOVE_FENCE = 'REMOVE_FENCE';
export const CLEAR_FENCE = 'CLEAR_FENCE';

// Job queue actions
export const SAGA_GET_JOBS = 'SAGA_GET_JOBS';

export const serverLoadFencesToBeValidated = (searchTerm, country) => {
    return {
        type: SAGA_LOAD_FENCES_TO_BE_VALIDATED,
        payload: {
			searchTerm,
			country,
		},
    }
}

export const serverLoadFence = (fenceId) => {
	return {
		type: SAGA_LOAD_FENCE,
		payload: {
			fenceId,
		}
	}
}

export const serverUpdateFence = (fenceId, geo) => {
	return {
		type: SAGA_UPDATE_FENCE,
		payload: {
			fenceId,
			geo,
		}
	}
}

export const serverDeleteFence = (fenceId, searchTerm='', country='') => {
	return {
		type: SAGA_DELETE_FENCE,
		payload: {
			fenceId,
			searchTerm,
			country,
		}
	}
}

export const serverValidateFence = (fenceId, searchTerm='', country='') => {
	return {
		type: SAGA_VALIDATE_FENCE,
		payload: {
			fenceId,
			country,
			searchTerm,
		},
	}
}

export const serverSetPrimary = (fenceId, poiId) => {
	return {
		type: SAGA_SET_FENCE_PRIMARY_POI,
		payload: {
			fenceId,
			poiId,
		}
	}
}

export const serverSkipFence = (fenceId, searchTerm='', country='') => {
	return {
		type: SAGA_SKIP_FENCE,
		payload: {
			fenceId,
			country,
			searchTerm,
		},
	}
}

export const setFencesToBeValidated = (fences) => {
	return {
		type: SET_FENCES_TO_BE_VALIDATED,
		payload: {
			fences,
		}
	}
}

export const setFence = (fence) => {
	return {
		type: SET_FENCE,
		payload: {
			fence,
		}
	}
}

export const removeFence = (fenceId) => {
	return {
		type: REMOVE_FENCE,
		payload: {
			fenceId,
		}
	}
}

export const clearFence = (fenceId) => {
	return {
		type: CLEAR_FENCE,
		payload: {
			fenceId,
		}
	}
}

export const setFenceUpdated = (geo) => {
	return {
		type: SET_FENCE_UPDATED,
		payload: {
			geo,
		}
	}
}

export const serverGetJobs = () => {
	return {
		type: SAGA_GET_JOBS,
		payload: {},
	}
}

export const serverMarkPOIValidationStageComplete = (poiId, stage) => {
	return {
		type: SAGA_MARK_POI_VALIDATION_STATE_COMPLETE,
		payload: {
			poiId,
			stage,
		}
	}
}

export const serverArchivePOI = (poiId) => {
	return {
		type: SAGA_ARCHIVE_POI,
		payload: {
			poiId,
		}
	}
}

export const serverMarkPOIUnsure = (poiId) => {
	return {
		type: SAGA_MARK_POI_UNSURE,
		payload: {
			poiId,
		}
	}
}


// WEBPACK FOOTER //
// ./src/validation/actions.js